var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
export var CarouselItem = function (_a) {
    var x = _a.x, index = _a.index, onDragEnd = _a.onDragEnd, children = _a.children, itemsPerPage = _a.itemsPerPage;
    return (_jsx(motion.div, __assign({ style: {
            x: x,
            left: "".concat(index * (100 / itemsPerPage), "%"),
            right: "".concat(index * (100 / itemsPerPage), "%"),
            width: "".concat(100 / itemsPerPage, "%"),
            height: "".concat(100 / itemsPerPage, "%"),
            display: 'grid',
            flex: 'none',
        }, drag: "x", dragElastic: 0.3, onDragEnd: onDragEnd }, { children: children })));
};
